"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScrollLayer = exports.createExternal = exports.updateAll = exports.create = exports.getLayersOnMainCamera = exports.getLayers = exports.getMasterLayers = void 0;
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var common_sidecar_1 = require("../../../main/common-sidecar");
function getMasterLayers() {
    assert_sidecar_1.assert.notNil(_masterLayers);
    return _masterLayers;
}
exports.getMasterLayers = getMasterLayers;
function getLayers() {
    assert_sidecar_1.assert.notNil(_layers);
    return _layers;
}
exports.getLayers = getLayers;
var _masterLayers = null;
var _layers = null;
var _layersOnMainCamera = [];
function getLayersOnMainCamera() {
    return _layersOnMainCamera;
}
exports.getLayersOnMainCamera = getLayersOnMainCamera;
var depth = 100;
function create() {
    // underPerf.recordCreate('layers')
    var scene = common_sidecar_1.common.getPhaserScene();
    _masterLayers = {
        game: scene.add.layer(),
        ui: scene.add.layer(),
        debug: scene.add.layer(),
    };
    _layers = {
        map: createLayer(_masterLayers.game),
        dungeonFeatures: createLayer(_masterLayers.game),
        items: createLayer(_masterLayers.game),
        monsters: createLayer(_masterLayers.game),
        fogOfWar: createLayer(_masterLayers.game),
        ui1: createLayer(_masterLayers.game),
        particles: createLayer(_masterLayers.game),
        lights: createLayer(_masterLayers.game),
        debugPhysics: createLayer(_masterLayers.game),
        uiOnCam: createLayer(_masterLayers.game),
        uiGame: createLayer(_masterLayers.ui, false),
        ui: createLayer(_masterLayers.ui, true),
        uiDialogBack: createLayer(_masterLayers.ui, true),
        uiDialog: createLayer(_masterLayers.ui, true),
        uiContextMenuBack: createLayer(_masterLayers.ui, true),
        uiContextMenu: createLayer(_masterLayers.ui, true),
        uiTooltip: createLayer(_masterLayers.ui, true),
        uiGame2: createLayer(_masterLayers.ui, true),
        uiMenuBackground: createLayer(_masterLayers.ui, true),
        uiMenu: createLayer(_masterLayers.ui, true),
        uiMenuMain: createLayer(_masterLayers.ui, true),
        uiMessage: createLayer(_masterLayers.ui, true),
        uiConfirm: createLayer(_masterLayers.ui, true),
        debug: createLayer(_masterLayers.debug),
    };
}
exports.create = create;
function updateAll() { }
exports.updateAll = updateAll;
function createExternal(baseLayer) {
    var scene = common_sidecar_1.common.getPhaserScene();
    var c = scene.add.container(0, 0);
    baseLayer.add(c);
    return c;
}
exports.createExternal = createExternal;
function createScrollLayer() {
    var scene = common_sidecar_1.common.getPhaserScene();
    var c = scene.add.container(0, 0);
    getMasterLayers().ui.add(c);
    c.depth = getLayers().uiContextMenuBack.depth - 1;
    return c;
}
exports.createScrollLayer = createScrollLayer;
function createLayer(masterLayer, isUi) {
    if (isUi === void 0) { isUi = false; }
    var scene = common_sidecar_1.common.getPhaserScene();
    assert_sidecar_1.assert.notNil(masterLayer);
    assert_sidecar_1.assert.notNil(_masterLayers);
    var c = scene.add.container(0, 0);
    masterLayer.add(c);
    // masterLayer.add(c)
    c.depth = depth;
    depth += 100;
    //if (masterLayer === _masterLayers.game) {
    //if (!isUi) {
    _layersOnMainCamera.push(c);
    //}
    //}
    if (isUi) {
        c.scrollFactorX = 0;
        c.scrollFactorY = 0;
    }
    return c;
}
